export const setSignupBanner = ({commit}, payload) => {
  commit('SET_SIGNUP_BANNER', payload);
}
